export default {
	baseUrl: "/api",
};
